import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyC_0L8HAGKbdRiIoj9pc625mmG0Th8YTcg",
  authDomain: "oursecretgarden.firebaseapp.com",
  projectId: "oursecretgarden",
  storageBucket: "oursecretgarden.firebasestorage.app",
  messagingSenderId: "442301214393",
  appId: "1:442301214393:web:8e842feb74a70a216f3568",
  measurementId: "G-19ME04Y2G7"
};

const app = firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };